import { createContext, useContext, useState } from 'react';
import { OverdueCustomer } from 'src/components/OverdueCustomerModal/types';

interface OverdueCustomerContextType {
  overdueCustomers: OverdueCustomer | undefined;
  setOverdueCustomers: (overdueCustomers: OverdueCustomer) => void;
  showOverdueCustomerModal: boolean;
  setShowOverdueCustomerModal: (showOverdueCustomerModal: boolean) => void;
}

export const OverdueCustomerContext = createContext<OverdueCustomerContextType>(
  {
    overdueCustomers: undefined,
    setOverdueCustomers: (overdueCustomers: OverdueCustomer | undefined) => {
      overdueCustomers = overdueCustomers;
    },
    showOverdueCustomerModal: false,
    setShowOverdueCustomerModal: (showOverdueCustomerModal: boolean) => {
      showOverdueCustomerModal = showOverdueCustomerModal;
    },
  }
);

export const OverdueCustomerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [overdueCustomers, setOverdueCustomers] = useState<
    OverdueCustomer | undefined
  >({
    account_suspended: false,
    invoices: [],
    user_id: 0,
  });
  const [showOverdueCustomerModal, setShowOverdueCustomerModal] =
    useState(false);
  return (
    <OverdueCustomerContext.Provider
      value={{
        overdueCustomers,
        setOverdueCustomers,
        showOverdueCustomerModal,
        setShowOverdueCustomerModal,
      }}
    >
      {children}
    </OverdueCustomerContext.Provider>
  );
};

export const useOverdueCustomer = () => {
  const context = useContext(OverdueCustomerContext);
  if (!context) {
    throw new Error(
      'useOverdueCustomer must be used within a OverdueCustomerProvider'
    );
  }
  const isSuspended =
    context.overdueCustomers?.account_suspended;
  const hasDebt =
    !context.overdueCustomers?.account_suspended &&
    (context.overdueCustomers?.invoices?.length ?? 0) > 0;

  return {
    ...context,
    isSuspended,
    hasDebt,
  };
};
